import { defineStore } from 'pinia'
import settingsApi from '../api/settings'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    settings: null,
    loaded: false,
  }),

  getters: {
    googleAuthEnabled: (state) => state.settings?.google_auth_enabled ?? true,
    facebookAuthEnabled: (state) => state.settings?.facebook_auth_enabled ?? false,
    emailRegistrationEnabled: (state) => state.settings?.email_registration_enabled ?? true,
    anyOAuthEnabled() {
      return this.googleAuthEnabled || this.facebookAuthEnabled
    },
    anyRegistrationEnabled() {
      return this.googleAuthEnabled || this.facebookAuthEnabled || this.emailRegistrationEnabled
    },
  },

  actions: {
    async fetchSettings() {
      if (this.loaded) return
      const response = await settingsApi.get()
      this.settings = response.data
      this.loaded = true
    },
  },
})
